export const selectShellUser = (state) => state.shellUserV2.shellUser

export const selectShellUserInvitee = (state) => state.shellUserV2.invitee

export const selectShellUserLenderId = (state) => state.shellUserV2.lender_id

export const selectShellUserCompanyId = (state) => state.shellUserV2.company

export const selectShellUserCompanyName = (state) => state.shellUserV2.company_name

export const selectShellUserInvitationReason = (state) => {
  return state.shellUserV2.invitation_type === 'company' ? 'As an appraiser panel member' : 'To join their company'
}

export const selectShellUserEmail = (state) => {
  const { email } = selectShellUser(state) || {}
  return email
}

export const selectShellUserFirstname = (state) => {
  const { firstname } = selectShellUser(state) || {}
  return firstname
}

export const selectShellUserLastname = (state) => {
  const { lastname } = selectShellUser(state) || {}
  return lastname
}

export const selectShellUserType = (state) => {
  const { userType } = selectShellUser(state) || {}
  return userType
}

export const selectShellUserStatus = (state) => state.shellUserV2.status

export const selectHasShellUserJwt = (state) => !!state.shellUserV2.shellUser?.jwt
